export type PricingFilter = {

	text: string,
	fixed: boolean,
	section: boolean,
	element: boolean,
	size: boolean,
}



export enum PriceModel {
  FIXED = 'fixed',
  SECTION = 'section',
  ELEMENT ='element',
  SIZE = 'size'
}

export enum DiscountType {
  VALUE = 'value',
  PERCENT = 'percent'
}
  
export enum DiscountModel {
  NONE = 'none',
  FIXED = 'fixed',
  DISCOUNT_ON_ADDITION = 'discount_on_addition'
}

export type Pricing = {
  name: string
  id: string
  price_model: PriceModel
  price: number
  discount_model: DiscountModel
  discount_type: DiscountType
  discount: number
  max_price_total: number
  min_price_total: number
}

export type PricingResponse = {
  contents: Pricing[],
  page: number,
  size: number
}